
export const networkErrors = {
  //general errors need to be an array
  noConnection: ["اتصال خود به شبکه اینترنت را بررسی نمایید"]
};





// WEBPACK FOOTER //
// ./src/helpers/consts.js